// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(true);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".general-central-reset-password-email{\n    width: 358px;\n    height: 260px;\n}", "",{"version":3,"sources":["webpack://src/components/security/login/EmailPassword.css"],"names":[],"mappings":"AAAA;IACI,YAAY;IACZ,aAAa;AACjB","sourcesContent":[".general-central-reset-password-email{\n    width: 358px;\n    height: 260px;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
